


































import Vue from 'vue';
import store from '@/store';

import { GoogleClassroomCourse, getClassrooms } from '@/api/auth/google';
import * as Api from '@/api';
import { WebRequestStatus, ApiPeerGroup } from '@/models';

import GoogleClassroomCoursePicker from '@/components/GoogleClassroomCoursePicker.vue';

export default Vue.extend({
  components: {
    GoogleClassroomCoursePicker
  },

  props: {
    initialName: String
  },

  data() {
    return {
      isOpen: false,
      courses: [] as GoogleClassroomCourse[],
      peerGroups: [] as ApiPeerGroup[],
      loadStatus: WebRequestStatus.READY
    };
  },

  computed: {
    activeAliases(): string[] {
      return this.peerGroups.flatMap(pg => (pg.alias ? [pg.alias] : []));
    },

    showSpinner(): boolean {
      return this.loadStatus === WebRequestStatus.IN_PROGRESS;
    },

    showPicker(): boolean {
      return this.loadStatus === WebRequestStatus.SUCCESS;
    }
  },

  methods: {
    close() {
      this.isOpen = false;
      this.loadStatus = WebRequestStatus.READY;
    },

    async init() {
      this.loadStatus = WebRequestStatus.IN_PROGRESS;

      try {
        const [courses, peerGroups] = await Promise.all([
          getClassrooms(),
          Api.secure.getPeerGroups()
        ]);

        this.courses = courses;
        this.peerGroups = peerGroups;

        this.loadStatus = WebRequestStatus.SUCCESS;
      } catch (error) {
        console.error(error);
        store.dispatch.org.displayErrorMessage(
          'Could not load classroom courses :('
        );

        this.loadStatus = WebRequestStatus.FAILURE;
      }
    },

    async select(classroomCourse: GoogleClassroomCourse) {
      this.loadStatus = WebRequestStatus.IN_PROGRESS;

      this.$emit('import', {
        course: classroomCourse
      });

      this.close();
    }
  },

  watch: {
    isOpen(value) {
      if (value) {
        this.init();
      }
    }
  }
});
